function devtricker_session_saveLikedComment(commentId) {
    const key = "devtricker_liked_comments";
    const stored = sessionStorage.getItem(key);
    const likedComments = stored ? JSON.parse(stored) : {};

    likedComments[commentId.toString()] = {
        commentId: commentId.toString(),
        dateAdded: new Date().toISOString()
    };

    sessionStorage.setItem(key, JSON.stringify(likedComments));
}

function devtricker_session_hasLikedComment(commentId) {
    const key = "devtricker_liked_comments";
    const stored = sessionStorage.getItem(key);
    const likedComments = stored ? JSON.parse(stored) : {};

    const data = likedComments[commentId.toString()];
    return data ? !!data.liked : null;
}

function devtricker_session_removeLikedComment(commentId) {
    const key = "devtricker_liked_comments";
    const stored = sessionStorage.getItem(key);
    const likedComments = stored ? JSON.parse(stored) : {};

    if (likedComments[commentId.toString()]) {
        delete likedComments[commentId.toString()];
        sessionStorage.setItem(key, JSON.stringify(likedComments));
    } else {
        devtricker_showCommentErrorToast();
    }
}

function devtricker_session_getLikedCommentDate(commentId) {
    const key = "devtricker_liked_comments";
    const stored = sessionStorage.getItem(key);
    const likedComments = stored ? JSON.parse(stored) : {};

    const liked = likedComments[commentId.toString()];
    if (liked && liked.dateAdded) {
        return new Date(liked.dateAdded);
    }

    return null;
}

function devtricker_session_setLikedCommentStatus(commentId, liked, likedAt) {
    
    const key = "devtricker_liked_comments";
    const stored = sessionStorage.getItem(key);
    const likedComments = stored ? JSON.parse(stored) : {};

    likedComments[commentId.toString()] = {
        commentId: commentId.toString(),
        liked: !!liked,
        dateAdded: likedAt || new Date().toISOString()
    };

    sessionStorage.setItem(key, JSON.stringify(likedComments));
}

function devtricker_session_getAllKnownCommentIds() {
    const key = "devtricker_liked_comments";
    const stored = sessionStorage.getItem(key);
    const likedComments = stored ? JSON.parse(stored) : {};

    return Object.keys(likedComments);
}